'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = require('./constants/');

var _constants2 = _interopRequireDefault(_constants);

var _services = require('./services/');

var _services2 = _interopRequireDefault(_services);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Want to add more shared files? go/generator-shared
 */
exports.default = angular.module('webPublicClient.app.shared', [_constants2.default.name, _services2.default.name]);


// WEBPACK FOOTER //
// ./src/app/shared/index.js